export class ReportStudioPageDesignOptionFactory {
  static buildDefaultPageDesignOptions() {
    return {
      background_color: '#ffffff',
      opacity: 1,
    };
  }
}
